var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calls-tab"},[_c('div',{staticClass:"calls-tab__table"},[_c('SubpanelTable',{class:['calls-tab__list'],attrs:{"tableColumns":_vm.columns,"tableData":_vm.calls,"resetHeight":true,"emptyText":!_vm.calls?.length ? 'Звонков нет' : '',"subpanelName":_vm.module,"resizable-table":true,"min-column-width":"150px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }